import axios from 'axios';

let prefix = "/user-address"

const UserAddressApi = {

	getUserAddressList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},

}

export default UserAddressApi;
